
import { useEffect, useState } from 'react';
import { Card, Row, Col, Form, Button, Table } from 'react-bootstrap';
import { faRotateLeft, faMagnifyingGlassPlus, faAnglesDown, faPenToSquare, faUserPlus, faUnlockKeyhole  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NewUserModal from '../NewUserModal/NewUserModal';
import EditUserModal from '../EditUserModal/EditUserModal';
import Swal from "sweetalert2";


const UserMainTable = () => {


    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));
    const [userListing, setUserListing] = useState([]);


    //ADD NEW USER MODAL CONTROLLER
    const [showModal_AddUser, setShowModal_AddUser] = useState(false);   
    const requestCloseModal_AddUser = () => { setShowModal_AddUser(false); getUsersListing(); }
    const openModal_AddUser = () => { setShowModal_AddUser(true); }


    //EDIT NEW USER MODAL CONTROLLER
    const [showModal_EditUser, setShowModal_EditUser] = useState(false);   
    const [userID, setUserID] =useState(false); 
    const requestCloseModal_EditUser = () => { setShowModal_EditUser(false); getUsersListing(); }
    const openModal_EditUser = (userID) => { setUserID(userID); setShowModal_EditUser(true); }


    //
    const [userSearch, setUserSearch] = useState("");


    const resetPassword = async (userID) => {
    
        //GET ORDER INFORMATION - WITH NO PASSWORD MEANS RESET PASSWORD TO BLANK
        let endpoint = "setPasswordUser?userID=" + userID;

        await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"}
        });
        

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Se ha reiniciado el password del usuario exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });
        
    } //END FUNCTION


    const changeUserStatus = async (userID, newUserStatus) => {
    
        //SET STATUS
        let endpoint = "setUserStatus?userID=" + userID + "&userStatus=" + newUserStatus;

        await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"}
        });

        
        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });


        //
        getUsersListing();
        
    } //END FUNCTION

    //
    const getUsersListing = async () =>{

        const endpoint = "getUsersListing";
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        const responseContent = await response.json();
        console.log(responseContent);
        setUserListing(responseContent);

    } //END FUNCTION


    useEffect(()=>{ 

        //
        if(!sessionUser || sessionUser.groupname != "Administrativos") {   
            window.location.href = "/"; 
        }

        //
        getUsersListing();

        
    }, []);



    return (

        <div style={{paddingLeft: "20px", paddingRight: "20px"}}>

            {/* SEARCH BOXES */}
            <Card variant="primary">
                <Card.Header style={{backgroundColor: "#404661", color: "white"}}></Card.Header>
                <Card.Body>

                    <Row>
                        <Col xs={12} md={4}>
                            <Form.Label className='subTitle_1'>Grupo de Usuarios</Form.Label>
                            <Form.Select style={{fontSize:"14px" }} onChange={(e)=>setUserSearch(e.target.value)} >

                                <option style={{fontSize:"14px"}}value="">Todos</option>
                                <option style={{fontSize:"14px"}} value="Administrativos" >Administrativos</option>
                                <option style={{fontSize:"14px"}} value="Clientes" >Clientes</option>
                                <option style={{fontSize:"14px"}} value="Técnicos" >Técnicos</option>

                            </Form.Select>
                        </Col>
                   
                    </Row>
                </Card.Body>
            </Card>
            <hr />

            {/* USER TABLE */}
            <Row style={{paddingLeft: "20px", paddingRight: "20px"}}>

                <Col xs={12} style={{textAlign:"right"}}>
                    <Button 
                        variant="outline-primary"
                        size="sm"
                        style={{width: "220px", marginLeft:"10px" }}
                        onClick = {openModal_AddUser}
                    >
                        Agregar Usuario
                        <FontAwesomeIcon icon={faUserPlus}
                        style={{paddingLeft:"20px"}}/>
                    </Button>
                </Col>
              
                <Col xs={12}>
                <hr />
                <Table striped className="mainTable">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Username</th>
                            <th>Grupo</th>
                            <th>Status</th>
                            <th style={{textAlign:"center"}}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>

                        {userListing.length > 0 && userListing.map((item)=>{

                            return (
                                
                                (userSearch === "" ? (

                                <tr key={item.id}>
                                    <td>{item.customer_name}</td>
                                    <td>{item.username}</td>
                                    <td>{item.groupname}</td>
                                    <td style={{color: (item.is_active === 0 ? "red" : "black")}}>
                                        
                                        {(item.is_active === 0 ? "Inactivo" : "Activo")}
                                        
                                    </td>

                                    <td style={{textAlign:"center"}}>

                                        { item.username !== "admin" ? 
                                            (
                                                <>
                                                <FontAwesomeIcon icon={faPenToSquare} 
                                                style={{paddingLeft:"20px", color: "black", cursor:"pointer"}} title='Editar Usuario' onClick={()=> {openModal_EditUser(item.id)}} />

                                                {(item.is_active === 1 ?
                                                    <FontAwesomeIcon icon={faAnglesDown} 
                                                    style={{paddingLeft:"20px", color: "blue", cursor:"pointer"}} title='Desactivar Usuario' onClick={()=> {changeUserStatus(item.id, 0)}} />
                                                :
                                                    <FontAwesomeIcon icon={faRotateLeft} 
                                                    style={{paddingLeft:"20px", color: "red", cursor:"pointer"}} title='Reactivar Usuario' onClick={()=> {changeUserStatus(item.id, 1)}} />)}

                                                <FontAwesomeIcon icon={faUnlockKeyhole} 
                                                style={{paddingLeft:"20px", color: "black", cursor:"pointer"}} title='Reset Password' onClick={()=>{resetPassword(item.id)}} />

                                                </>

                                            ) : ""
                                        }

                                    </td>
                                </tr>

                                ) : 
                                
                                    (item.groupname === userSearch ? (


                                        <tr key={item.id}>
                                            <td>{item.customer_name}</td>
                                            <td>{item.username}</td>
                                            <td>{item.groupname}</td>
                                            <td style={{color: (item.is_active === 0 ? "red" : "black")}}>
                                                
                                                {(item.is_active === 0 ? "Inactivo" : "Activo")}
                                                
                                            </td>

                                            <td style={{textAlign:"center"}}>

                                                { item.username !== "admin" ? 
                                                    (
                                                        <>
                                                        <FontAwesomeIcon icon={faPenToSquare} 
                                                        style={{paddingLeft:"20px", color: "black", cursor:"pointer"}} title='Editar Usuario' onClick={()=> {openModal_EditUser(item.id)}}  />

                                                        {(item.is_active === 1 ?
                                                            <FontAwesomeIcon icon={faAnglesDown} 
                                                            style={{paddingLeft:"20px", color: "blue", cursor:"pointer"}} title='Desactivar Usuario' onClick={()=> {changeUserStatus(item.id, 0)}} />
                                                        :
                                                            <FontAwesomeIcon icon={faRotateLeft} 
                                                            style={{paddingLeft:"20px", color: "red", cursor:"pointer"}} title='Reactivar Usuario' onClick={()=> {changeUserStatus(item.id, 1)}} />)}

                                                        <FontAwesomeIcon icon={faUnlockKeyhole} 
                                                        style={{paddingLeft:"20px", color: "black", cursor:"pointer"}} title='Reset Password' onClick={()=>{resetPassword(item.id)}} />

                                                        </>

                                                    ) : ""
                                                }

                                            </td>
                                        </tr>

                                    ) : "" )
                            
                                )


                            )
                        })}
                    </tbody>
                </Table>
                </Col>
            </Row>


            {/* MODAL ADD USER COMPONENT */}
            <NewUserModal show={showModal_AddUser} requestClose={requestCloseModal_AddUser}/>


            {/* MODAL EDIT USER COMPONENT */}
            <EditUserModal show={showModal_EditUser} requestClose={requestCloseModal_EditUser} userID={userID} />


        </div>
    );

} //end



export default UserMainTable;
